import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  optionsContainer: {
    gap: Spacing.Condensed,
    width: '100%',
  },
  qualityOption: {
    height: 52,
    width: '100%',
    paddingHorizontal: 24,
    paddingVertical: 11.5,
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: Spacing.Compact,
  },
  option: {
    textAlign: 'left',
    ...textLatoStyleDS.BodyBoldMd,
  },
  qualityIcon: { width: 16, height: 16, color: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightIconDefault },
});
